import { useEffect, useLayoutEffect, useRef } from 'react';

import { apriLivello } from '@/lib/livelliIndietro';

/**
 * Un livello sopra le rotte (foglio, modale): finche' `attivo`, il tasto indietro di Telegram chiude
 * QUESTO e non cambia schermata (v. `lib/livelliIndietro.ts`).
 *
 * ⚠️ L'effetto dipende SOLO da `attivo`: `chiudi` sta in un ref aggiornato a ogni render. Cosi' una
 * callback nuova (un `onClose` scritto in linea, cioe' quasi sempre) non ri-registra il livello, e non lo
 * porta in cima sopra un livello aperto DOPO di lui.
 *
 * ⚠️ L'aggiornamento del ref e' un `useLayoutEffect`, non un `useEffect` (seguito di #441, revisione
 * tma-orcb 26/09): un effetto passivo gira DOPO che il browser puo' gia' aver gestito un input, quindi
 * fra il commit di un `chiudi` nuovo e il suo arrivo nel ref c'e' una finestra di pochi ms in cui un
 * indietro chiamerebbe la callback VECCHIA. `useLayoutEffect` gira dopo il commit e prima che il browser
 * gestisca un input: la finestra si chiude nel modo previsto da React. ⛔ Non si scrive `ref.current =
 * chiudi` direttamente nel corpo del render (pattern che il repo usa altrove, es. `useMainButton.ts`): con
 * il rendering concorrente un render scartato lascerebbe nel ref la closure di uno stato mai confermato —
 * il problema al contrario.
 */
export function useLivelloIndietro(attivo: boolean, chiudi: () => void): void {
  const ref = useRef(chiudi);
  useLayoutEffect(() => {
    ref.current = chiudi;
  });
  useEffect(() => {
    if (!attivo) return;
    return apriLivello(() => ref.current());
  }, [attivo]);
}
